
import {
    PrescriptionRenewalSurveyResultsArray,
    PrescriptionRenewalSurveyResultsViewProps,
} from './types'
import {
    captionTitle, cellInner, copyButtonWrapper, styledPrescriptionRenewalSurveyResultsView,
} from './styles/PrescriptionRenewalSurveyResultsView'
import {CopyButton} from 'components/AudienceMetadata/components/CopyButton'
import {LockClosedIcon} from '../Icon'
import React from 'react'
import {buttonContainer} from 'components/AudienceMetadata/styles/AudienceMetadata'
import {styled} from 'stitches/config'
import {toast} from 'components/Toast'
import {useCopyToClipboard} from 'hooks/clipboard'
import {useTranslation} from 'react-i18next'

const StyledPrescriptionRenewalSurveyResultsView = styled('div', styledPrescriptionRenewalSurveyResultsView)
const StyledButtonContainer = styled('div', buttonContainer)
const StyledTableCaption = styled('caption', {[`& ${StyledButtonContainer}`]: {visibility: 'visible'}})
const StyledCaptionTitle = styled('div', captionTitle)
const StyledCopyButton = styled('div', copyButtonWrapper)

const StyledCellInner = styled('div', {
    ...cellInner,
    '&:hover': {
        [`${StyledCopyButton}`]: {visibility: 'visible'},
        backgroundColor: '$metadataItemBackgroundHover',
        borderRadius: '$metadataItemBorder',
    },
})

const yesNoKeys: Record<string, string> = {
    NO: 'No',
    YES: 'Yes',
}

const renderValue = (value: string, t: (key: string) => string): React.ReactElement => {
    const key = yesNoKeys[value]
    return <span className='value'>{key ? t(key) : value || '--'}</span>
}

const prepareCopyString = (data: PrescriptionRenewalSurveyResultsArray[], t: (key: string) => string) => data.reduce((acc, [_key, value, title]) => {
    const key = yesNoKeys[value]
    return `${acc}${'\n\n'}${title}: ${key ? t(key) : value || '--'}`
}, '')

const PrescriptionRenewalSurveyResultsView = (props: PrescriptionRenewalSurveyResultsViewProps): React.ReactElement => {
    const {data} = props
    const {t} = useTranslation()

    const clipboard = useCopyToClipboard({
        onSuccess: (key) => {
            toast.success(t('Copied: {{key}}', {key}))
        },
    })

    const handleCopy = (toCopy: string, copyKey: string) => () => {
        clipboard.copy(toCopy, copyKey)
    }

    const header = t('Summary of client\'s answers to questionnaire')
    const stringToCopy = prepareCopyString(data, t)

    return (
        <StyledPrescriptionRenewalSurveyResultsView>
            <table>
                <StyledTableCaption title={header}>
                    <StyledCaptionTitle><LockClosedIcon />{header}</StyledCaptionTitle>
                    <StyledButtonContainer>
                        <CopyButton
                            currentKey=''
                            currentValue={{[header]: stringToCopy}}
                            showCopyAll={true}
                        />
                    </StyledButtonContainer>
                </StyledTableCaption>
                <tbody>
                    {data.map((item) => {
                        const itemCopyString = prepareCopyString([item], t)
                        return (
                            <tr key={item[0]}>
                                <td>
                                    <StyledCellInner onClick={handleCopy(itemCopyString, item[2])}>
                                        <div>
                                            <div>
                                                <span className='blockKey'>{item[2]}:</span>
                                            </div>
                                            <StyledCopyButton>
                                                <CopyButton currentKey={item[2]} currentValue={itemCopyString} showCopyAll={false} />
                                            </StyledCopyButton>
                                        </div>
                                        {renderValue(item[1], t)}
                                    </StyledCellInner>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </StyledPrescriptionRenewalSurveyResultsView>
    )
}

export default PrescriptionRenewalSurveyResultsView

